import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Internal Complaints Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>



                            < Col md={9} className='c-left  text-dark custom-padding-color'>
                                <h3 className='c-headline mb-3'>Internal Complaints Committee</h3>
                                <p className='fw-bold c-lineheight2dot5'>In accordance with the provisions of the Sexual Harassment of Women at Workplace (Prevention, Prohibition & Redressal) Act, 2013, the Internal Complaints Committee of IIT Tirupati, is constituted with the following composition:
                                    Any complaint of Sexual Harassment may be reported to <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> </p>

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Prof. T Sita Kumari</p>
                                                <p>Professor - Department of Law, <br /> Sri Padmavathi Mahila Visvavidyalayam</p>
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. N. Venkaiah</p>
                                                <p>Associate Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Gowri A</p>
                                                <p>Associate Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Arun Kalyan</p>
                                                <p>Assistant Registrar</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mrs. Sandhya Y</p>
                                                <p>Section Officer</p>
                                            </td>
                                            <td>Member / Convenor</td>
                                        </tr>
                                    </tbody>

                                </Table>

                                <p className="mt-2 mb-2">The following persons will also be included as members of the Committee in case the victim or alleged perpetrator is a student: </p>

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Mr. Pujari Rudransh (ME20B032)</p>
                                                <p>Students' General Secretary</p>
                                            </td>
                                            <td>Member - Ex Officio</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Ms. Aiswarya Pradeep (HS22D501)</p>
                                                <p>Ph.D Scholar</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Ms. Vineeta Gupta (EE21S504)</p>
                                                <p>MS (Research) Student</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                    </tbody>
                                </Table>


                                <h3 className='c-headline mt-5 mb-3'>The Role of the Committee:</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To act as Inquiry Authority on a complaint of sexual harassment.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To ensure that victims and witnesses are not victimised or discriminated because of their complaint.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To take proactive measures towards sensitization of staff, students and faculty member of IIT Tirupati on gender issues.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />To discharge any other functions as per the Act.</li>
                                </ul>

                                <h3 className='c-headline mt-5 mb-3'>Women at work place: Working without Harassment</h3>
                                <p className='fw-bold'>The Supreme Court has defined ‘sexual harassment’ to include:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Physical contact and advances</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />A demand or request for sexual favours</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Sexually coloured remarks</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Showing pornography</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Any other unwelcome physical, verbal or non-verbal conduct of sexual nature.</li>
                                </ul>


                                <p className='mt-3'>Often such behaviour goes unpunished because of hesitation on the part of women to report such behaviour out of a sense of shame or fear. It is important for women to protest against any behaviour that they feel is unwanted and unacceptable. The Internal Complaints Committee at IIT Tirupati has been set up with the aim of providing women an appropriate complaint mechanism against unwelcome sexually determined behaviour whether directly or by implication.</p>


                                <h3 className='c-headline mt-5 mb-3'>What should you do, if you are sexually harassed?</h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Do not feel ashamed. Tell the harasser very clearly that you find his behavior offensive.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Do not ignore the harassment in the hope that it will stop on its own. Come forward and complain to the Internal Complaints Committee.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />Talk to somebody you trust about the harassment. It will not only give you strength but also help others in similar situations to come forward and complain.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Keep a record of all incidents of sexual harassment. If you feel the need to register a formal complaint later, this record will be helpful.</li>
                                </ul>


                                <h3 className='c-headline mb-3 mt-5'> What action can be taken against the offender? </h3>
                                <div className='c-lineheight2dot5'>
                                    <p>The Internal Complaints Committee is deemed to be an Inquiry Authority for the purpose of CCS(Conduct) Rules, 1964 and the report of the Internal Complaints Committee is deemed to be an Inquiry Report under the rules.  </p>
                                    <p>Once it is proved that the offender has indulged in sexual harassment in the work place, appropriate disciplinary action would be taken against him irrespective of his status in IIT Tirupati (staff, faculty, student) Where such conduct amounts to a specific offense under the Indian Penal Code, a complaint will be made to the appropriate authority for action in accordance with the law.</p>
                                    <p>Care shall be taken by the committee to ensure that the victims of sexual harassment and the witnesses shall not be victimized while dealing with the complaint. The victims also have the option to seek transfer of the perpetrator or their own transfer.</p>
                                </div>


                            </Col>

                            <Col md={3} className='c-right c-lineheight2dot5 text-dark'>
                                <h3 className='c-headline mb-3'> Documents </h3>
                                <ul className='ms-3 c-lineheight2dot5 iarrow' >
                                    <li className=''><i className="fal fa-arrow-alt-circle-right me-3 c-arrow" /><Link className='c-link' to="https://files.iittp.ac.in/pdfs/VishakaVsRajasthan_1997.pdf" target="_blank" > Vishaka Vs State of Rajasthan</Link> </li>
                                    <li className=''><i className="fal fa-arrow-alt-circle-right me-3 c-arrow" /><Link className='c-link' to="https://files.iittp.ac.in/pdfs/shc_acts2013.pdf" target="_blank" > The Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013  </Link> </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-arrow" /><Link className='c-link' to="https://files.iittp.ac.in/pdfs/shc_rules2013.pdf" target="_blank" > The Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Rules, 2013  </Link> </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-arrow" /><Link className='c-link' to="https://files.iittp.ac.in/pdfs/Handbook_SHW_Workplace.pdf" target="_blank" > Handbook on Sexual Harassment of Women at Workplace</Link> </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-arrow" /><Link className='c-link' to="https://files.iittp.ac.in/pdfs/SAKSHAM.pdf" target="_blank" > SAKSHAM - Measures for Ensuring the Safety of Women and Programmes for Gender Sensitization on Campuses - UGC Report </Link> </li>

                                    
                                </ul>
                            </Col>
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;